import { useTranslation } from "react-i18next";
import { Page } from "../../expenses/components/ui";
import PaymentTermsCard from "./PaymentTermsCard";

// Configuración → General: ajustes que valen para todas las apps de finanzas y
// no pertenecen a categorías ni a tipo de cambio. Hoy, el plazo de pago de
// omisión de las facturas a clientes (#1421).

export default function GeneralSection() {
  const { t } = useTranslation("common");
  return (
    <Page title={t("financeSettings.general.title")} subtitle={t("financeSettings.general.subtitle")}>
      <PaymentTermsCard />
    </Page>
  );
}
